import { CsrDetalhe } from "./csrDetalhe";
import { CsrDetalhePj } from "./csrDetalhePj";

export class Csr{
    id: number;
    nomeAmigavel: string;
    csrDetalhe: CsrDetalhe;
    csrDetalhePj: CsrDetalhePj;
}
